import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[1400px] flex-1 flex-col items-center justify-center px-4 py-20 text-center md:px-6">
        <p className="font-heading text-6xl font-bold text-primary-500 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">这个页面走丢了</h1>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
          路径 <span className="font-mono text-xs text-foreground-700">{location.pathname}</span> 暂未收录，可能是链接有误。去首页看看最新的影视资讯吧。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <Link to="/" className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600">
            返回首页
          </Link>
          <Link to="/category/电影" className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition hover:border-primary-400">
            浏览电影分类
          </Link>
          <Link to="/search" className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition hover:border-primary-400">
            搜索作品
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}